import { SideBarItem, SideBarItemProps } from "@/components/app/SideBars/SideBarItem.tsx"
import { SideBar } from "@/components/app/SideBars/SideBar.tsx"
import TaskList from "@spectrum-icons/workflow/TaskList"
import History from "@spectrum-icons/workflow/History"
import Histogram from "@spectrum-icons/workflow/Histogram"
import ViewList from "@spectrum-icons/workflow/ViewList"
import UserArrow from "@spectrum-icons/workflow/UserArrow"
import Alert from "@spectrum-icons/workflow/Alert"
import AddCircle from "@spectrum-icons/workflow/AddCircle"
import Annotate from "@spectrum-icons/workflow/Annotate"
import Article from "@spectrum-icons/workflow/Article"
import Attributes from "@spectrum-icons/workflow/Attributes"
import Asterisk from "@spectrum-icons/workflow/Asterisk"
import Beaker from "@spectrum-icons/workflow/Beaker"
import Blur from "@spectrum-icons/workflow/Blur"
import BoxExport from "@spectrum-icons/workflow/BoxExport"
import Breakdown from "@spectrum-icons/workflow/Breakdown"
import CollectionEdit from "@spectrum-icons/workflow/CollectionEdit"
import Document from "@spectrum-icons/workflow/Document"
import Monitoring from "@spectrum-icons/workflow/Monitoring"
import Slice from "@spectrum-icons/workflow/Slice"
import Sync from "@spectrum-icons/workflow/Sync"
import Temperature from "@spectrum-icons/workflow/Temperature"
import Visibility from "@spectrum-icons/workflow/Visibility"
import AnnotatePen from "@spectrum-icons/workflow/AnnotatePen"
import Teapot from "@spectrum-icons/workflow/Teapot"
import FileChart from "@spectrum-icons/workflow/FileChart"
import DataMapping from "@spectrum-icons/workflow/DataMapping"

// Predefined vibrant colors
const vibrantColors = {
  red: "#FF3B30",
  orange: "#FF9500",
  yellow: "#FFCC00",
  green: "#34C759",
  teal: "#5AC8FA",
  blue: "#007AFF",
  purple: "#5856D6",
  pink: "#FF2D55",
  indigo: "#5E5CE6",
  cyan: "#00BCD4",
  lime: "#CDDC39",
  deepPurple: "#673AB7",
  amber: "#FFC107",
  deepOrange: "#FF5722",
  lightBlue: "#03A9F4"
};

const sideBarItems:SideBarItemProps[] = [
  {
    route: "activityChart",
    label: "Activity Chart",
    icon: <FileChart UNSAFE_style={{color: vibrantColors.red}}/>,
  },
  {
    route: "alerts",
    label: "Alerts",
    icon: <Alert UNSAFE_style={{color: vibrantColors.orange}} />,
  },
  {
    route: "assessmentScores",
    label: "Assessment Scores",
    icon: <Annotate UNSAFE_style={{color: vibrantColors.yellow}} />,
  },
  {
    route: "caseSheet",
    label: "Case Sheet",
    icon: <Article UNSAFE_style={{color: vibrantColors.green}} />,
  },
  {
    route: "clinicalScores",
    label: "Clinical Scores",
    icon: <CollectionEdit UNSAFE_style={{color: vibrantColors.teal}} />,
  },
  {
    route: "consentForms",
    label: "Consent Forms",
    icon: <Asterisk UNSAFE_style={{color: vibrantColors.blue}} />,
  },
  {
    route: "dialysis",
    label: "Dialysis",
    icon: <Attributes UNSAFE_style={{color: vibrantColors.purple}} />,
  },
  {
    route: "dietician",
    label: "Dietician",
    icon: <Teapot UNSAFE_style={{color: vibrantColors.pink}} />,
  },
  {
    route: "dischargeSummary",
    label: "Discharge Summary",
    icon: <BoxExport UNSAFE_style={{color: vibrantColors.indigo}} />,
  },
  {
    route: "doctor",
    label: "Doctor",
    icon: <AddCircle UNSAFE_style={{color: vibrantColors.cyan}} />,
  },
  {
    route: "eMar",
    label: "eMAR",
    icon: <DataMapping UNSAFE_style={{color: vibrantColors.lime}} />,
  },
  {
    route: "gcs",
    label: "GCS",
    icon: <Visibility UNSAFE_style={{color: vibrantColors.deepPurple}} />,
  },
  {
    route: "grbs",
    label: "GRBS",
    icon: <Blur UNSAFE_style={{color: vibrantColors.amber}} />,
  },
  {
    route: "hicBundles",
    label: "HIC Bundles",
  },
  {
    route: "himsDischargeSummary",
    label: "HIMS Discharge Summary",
    icon: <Breakdown UNSAFE_style={{color: vibrantColors.deepOrange}} />,
  },
  {
    route: "inputOutput",
    label: "Input/Output",
    icon: <Sync UNSAFE_style={{color: vibrantColors.lightBlue}} />,
  },
  {
    route: "investigationResults",
    label: "Investigation Results",
    icon: <Beaker UNSAFE_style={{color: vibrantColors.red}} />,
  },
  {
    route: "longitudinalHistory",
    label: "Longitudinal History",
    icon: <History UNSAFE_style={{color: vibrantColors.orange}} />,
  },
  {
    route: "nurseTodo",
    label: "Nurse TODO",
    icon: <TaskList UNSAFE_style={{color: vibrantColors.yellow}} />,
  },
  {
    route: "nursing",
    label: "Nursing",
    icon: <Temperature UNSAFE_style={{color: vibrantColors.green}} />,
  },
  {
    route: "operationTheatre",
    label: "Operation Theatre",
    icon: <Slice UNSAFE_style={{color: vibrantColors.teal}} />,
  },
  {
    route: "procedureReport",
    label: "Procedure Report",
    icon: <Document UNSAFE_style={{color: vibrantColors.blue}} />,
  },
  {
    route: "rehabilitationNotes",
    label: "Rehabilitation Notes",
    icon: <AnnotatePen UNSAFE_style={{color: vibrantColors.purple}} />,
  },
  {
    route: "taskAssigner",
    label: "Task Assigner",
    icon: <UserArrow UNSAFE_style={{color: vibrantColors.pink}} />,
  },
  {
    route: "tasksList",
    label: "Tasks List",
    icon: <ViewList UNSAFE_style={{color: vibrantColors.indigo}} />,
  },
  {
    route: "vitals",
    label: "Vitals",
    icon: <Monitoring UNSAFE_style={{color: vibrantColors.cyan}} />,
  },
]

export function PatientSideBar() {
  return (
    <SideBar position="left">
      {sideBarItems.map((item) => {
        return (
          <SideBarItem
            key={item.route}
            label={item.label}
            route={item.route}
            icon={item.icon}
          />
        )
      })}
    </SideBar>
  )
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function SideItems() {
  return (
    <>
      <SideBarItem
        route="activityChart"
        label="Activity Chart"
        icon={<Histogram size="M" alignSelf="center" marginX="size-125" />}
      />
      <SideBarItem
        route="alerts"
        label="Alerts"
        icon={<Alert size="M" alignSelf="center" marginX="size-125" />}
      />
      <SideBarItem route="assessmentScores" label="Assessment Scores" />
      <SideBarItem route="caseSheet" label="Case Sheet" />
      <SideBarItem route="clinicalScores" label="Clinical Scores" />
      <SideBarItem route="consentForms" label="Consent Forms" />
      <SideBarItem route="dialysis" label="Dialysis" />
      <SideBarItem route="dietician" label="Dietician" />
      <SideBarItem route="dischargeSummary" label="Discharge Summary" />
      <SideBarItem route="doctor" label="Doctor" />
      <SideBarItem route="eMar" label="eMAR" />
      <SideBarItem route="gcs" label="GCS" />
      <SideBarItem route="grbs" label="GRBS" />
      <SideBarItem route="hicBundles" label="HIC Bundles" />
      <SideBarItem
        route="himsDischargeSummary"
        label="HIMS Discharge Summary"
      />
      <SideBarItem route="inputOutput" label="Input/Output" />
      <SideBarItem route="investigationResults" label="Investigation Results" />
      <SideBarItem
        route="longitudinalHistory"
        label="Longitudinal History"
        icon={
          <History
            size="M"
            alignSelf="center"
            marginX="size-125"
            color="notice"
          />
        }
      />
      <SideBarItem
        route="nurseTodo"
        label="Nurse TODO"
        icon={
          <TaskList
            size="M"
            alignSelf="center"
            marginX="size-125"
            color="notice"
          />
        }
      />
      <SideBarItem route="nursing" label="Nursing" />
      <SideBarItem route="operationTheatre" label="Operation Theatre" />
      <SideBarItem route="procedureReport" label="Procedure Report" />
      <SideBarItem route="rehabilitationNotes" label="Rehabilitation Notes" />
      <SideBarItem
        route="taskAssigner"
        label="Task Assigner"
        icon={<UserArrow size="M" alignSelf="center" marginX="size-125" />}
      />
      <SideBarItem
        route="tasksList"
        label="Tasks List"
        icon={<ViewList size="M" alignSelf="center" marginX="size-125" />}
      />
      <SideBarItem route="vitals" label="Vitals" />
    </>
  )
}
